import classNames from "classnames";
import moment from "moment";
import { useEffect, useState } from "react";

export const GenericForm = (props) => {
    const { fields,
        fieldClass = '',
        initVals = {},
        onSubmit,
        cancelLabel = 'Cancel',

        submitLabel = 'Save',
        submitOptions = { className: 'ds-btn is-primary' },
        onCancel,
        cancelOptions = {
            className: 'ds-btn is-ghost'
        },
        wrapClass,
        chidlren,
        formClass } = props;

    const [formFields, setFormFields] = useState([]);

    useEffect(() => {
        if (!Array.isArray(fields)) {
            return;
        }
        const data = fields.map((item) => {
            let defaultValue = null;
            if (initVals[item.name]) {
                defaultValue = initVals[item.name];
                if (item.type === 'date') {
                    defaultValue = moment(initVals[item.name]).format('YYYY-MM-DD');
                }
            }
            return Object.assign({ defaultValue }, item);
        })
        setFormFields(data)
    }, [fields, initVals])


    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = {}
        for (const [key, value] of formData) {
            data[key] = value;
        }
        if (onSubmit) {
            onSubmit(data);
        }
    }

    return <form onSubmit={handleSubmit} className={formClass}>
        {formFields.map((item, idx) => {
            let formElem = null;
            const { element, labelOptions, ...inputOptions } = item;
            if (!inputOptions.name) {
                return (<div>Missing name field for item # {idx}</div>)
            }

            inputOptions.className = classNames(fieldClass, item.className); 
            if (element === 'input' || !element) {
                formElem = <input  {...inputOptions}
                />
            } else if (element === 'select') {
                const { options, ...selectOptions } = inputOptions;
                formElem = <select {...selectOptions}  >
                    {item.options?.map(opt => {
                        return <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    })}
                </select>
            } else {
                formElem = <input {...item} />
            }
            const labelProps = { className: 'ds-label', ...labelOptions };
            return <div className={ item.wrapClass ? item.wrapClass: wrapClass} key={`input-${idx}`}>
                {item.label && <label {...labelProps}>{item.label}</label>}
                {formElem}
            </div>
        })}
        {chidlren}
        <div className='ds-form-actions'>
            {onCancel && <button onClick={onCancel} type="button" {...cancelOptions}> {cancelLabel}</button>}
            <button type="submit" {...submitOptions}> {submitLabel}</button>
        </div>
    </form>
}

